<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';
import ConfirmResetAllStudentTagAssociationsModal from '@/components/elements/ConfirmationModal';

export default {
    components: {
        ConfirmResetAllStudentTagAssociationsModal
    },

    page: {
        title: 'Student tags'
    },

    extends: TableView,

    data() {
        const defaultNoDataText =
            'Use the search field to find a relevant student';

        return {
            pageTitle: 'Student tags',
            includeDeleteAction: false,
            noDataText: defaultNoDataText,
            defaultNoDataText
        };
    },

    computed: {
        labels() {
            return [
                { value: 'firstName', width: '150px' },
                { value: 'lastName', width: '150px' },
                { value: 'tz', width: '150px' },
                { value: 'phone', width: '150px' },
                {
                    text: 'Category name',
                    value: 'tag.category.name',
                    width: '150px',
                    sortFieldName: 'tags.category.name'
                },
                {
                    text: 'Tag name',
                    value: 'tag.name',
                    width: '150px',
                    sortFieldName: 'tags.name'
                }
            ];
        },

        options() {
            return {
                filters: false,
                addButton: false,
                pagination: false,
                noDataText: this.noDataText
            };
        },

        globalActions() {
            return [
                {
                    class: 'btn btn-danger waves-effect waves-light mr-1 mb-1',
                    icon: 'fa fa-broom',
                    text: 'Reset all Student-Tag associations',
                    method: this.openConfirmResetAllStudentTagAssociationsModal
                }
            ];
        },

        additionalComponents() {
            return [
                {
                    name: 'confirm-reset-all-student-tag-associations-modal',
                    props: {
                        id: 'confirm-reset-all-student-tag-associations-modal',
                        title: 'You will reset ALL Student-Tag associations. Are you sure you want to continue?'
                    },
                    events: {
                        agree: this.doResetAllStudentTagAssociations
                    }
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'students/tagAssociations',
            resetAllStudentTagAssociations:
                'students/resetAllStudentTagAssociations'
        }),

        onRowClick({ id, tag }) {
            this.$router.push(
                `/student-tags-list/${id}/${tag?.id ? `${tag?.id}/` : ''}edit`
            );
        },

        async fetchItems() {
            this.isLoading = true;

            try {
                const data = {
                    ...this.pagination,
                    filters: this.filters,
                    ...this.additionalFetchData,
                    fetchFromAguda: true
                };

                let { count, rows, message } = await this.getItems(data);

                const newRows = [];

                for (const row of rows) {
                    if (row.tags.length) {
                        for (const tag of row.tags) {
                            const newRow = {
                                ...row,
                                tag
                            };

                            newRows.push(newRow);
                        }
                    } else {
                        newRows.push(row);
                    }
                }

                this.items = newRows;
                this.pagination.total = count;
                this.noDataText = message ? message : this.defaultNoDataText;
            } catch (err) {
                console.error(err);

                this.$toasterError();
            }

            this.isLoading = false;
        },

        openConfirmResetAllStudentTagAssociationsModal() {
            this.$bvModal.show(
                'confirm-reset-all-student-tag-associations-modal'
            );
        },

        async doResetAllStudentTagAssociations() {
            try {
                await this.resetAllStudentTagAssociations();

                this.pagination.currentPage = 1;

                await this.fetchItems();

                this.$toaster(
                    'Reset all Student-Tag associations completed successfully'
                );
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }
        }
    }
};
</script>
